<template>
    <div>
        <div class="crumbs">
            <Breadcrumb v-bind:menuList="menuList"></Breadcrumb>
        </div>
        <div class="container">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="订单编号:">
                    <el-input class="s-input" v-model="queryParams.ordersn" placeholder="请输入订单编号" clearable></el-input>
                </el-form-item>
                <el-form-item label="支付状态:">
                    <el-select v-model="queryParams.pay_state" placeholder="请选择支付状态" clearable @change="changeQuery">
                        <el-option label="未支付" :value="0"></el-option>
                        <el-option label="已支付" :value="2"></el-option>
                    </el-select>
                </el-form-item>

                <div style="float: right">
                    <el-button type="primary" @click="changeQuery()">搜索</el-button>
                </div>
            </el-form>
            <!-- 表格内容 -->
            <el-table v-loading="loading" element-loading-text="数据加载中" stripe border :data="pageInfo.list" style="margin-top: 10px;">
                <el-table-column label="id" prop="id" width="100" align="center"></el-table-column>
                <el-table-column label="等级名称" prop="title" align="center"></el-table-column>
                <el-table-column label="订单号" prop="ordersn" align="center" width="200"></el-table-column>
                <el-table-column label="支付时间 " prop="pay_time" width="200" align="center"></el-table-column>
                <el-table-column label="价格" prop="price" width="200" align="center"></el-table-column>
                <el-table-column label="支付方式" prop="pay_type" width="200" align="center">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.pay_type === 1">微信</el-tag>
                        <el-tag type="primary" v-if="scope.row.pay_type === 2">支付宝</el-tag>
                        <el-tag type="primary" v-if="scope.row.pay_type === 3">银行卡</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="支付状态" prop="pay_state" align="center" width="200">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.pay_state === 0">未支付</el-tag>
                        <el-tag type="primary" v-if="scope.row.pay_state === 2">已支付</el-tag>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <Pagination v-bind:pageInfo="pageInfo" v-on:refreshPageSize="refreshPageSize" v-on:refreshPageNum="refreshPageNum" />
        </div>
        <!-- 编辑添加邀请码 -->
        <el-dialog :title="title" :visible.sync="addVisible" width="50%">
            <el-form class="form-box" ref="form" v-bind:rules="rules" v-bind:model="form" v-loading.body="loading" label-position="right" label-suffix=":" label-width="150px" size="large" element-loading-text="上传中">
                <el-form-item label="等级名称" prop="name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="消费折扣" prop="consumption">
                    <el-input v-model="form.consumption"></el-input>
                </el-form-item>
                <el-form-item label="售后秒退" prop="customer">
                    <el-input v-model="form.customer"></el-input>
                </el-form-item>
                <el-form-item label="是否包邮" prop="shipping">
                    <el-radio-group v-model="form.shipping">
                        <el-radio :label="2">是</el-radio>
                        <el-radio :label="1">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否可以开通店铺" prop="shop">
                    <el-radio-group v-model="form.shop">
                        <el-radio :label="2">是</el-radio>
                        <el-radio :label="1">否</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveData">提 交</el-button>
            </div>
        </el-dialog>
        <!-- 上线、下线提示框 -->
        <el-dialog title="提示" :visible.sync="confirmVisible" width="300px" center>
            <div class="del-dialog-cnt">{{ confirmContent }}</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmVisible = false">取 消</el-button>
                <el-button type="primary" @click="stateData">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import Breadcrumb from '@/components/Breadcrumb'
import Pagination from '@/components/Pagination'
import { request } from '@/common/request'
import { deal } from '@/common/main'
export default {
    name: 'StoreInfo',
    components: {
        Breadcrumb,
        Pagination
    },
    data() {
        return {
            menuList: ['客户', '等级订单'],
            loading: false,
            confirmVisible: false,
            confirmContent: '',
            queryParams: {
                page: 1,
                pagesize: 10,

            },
            pageInfo: {},
            brandList: [],
            addVisible: false,
            addVisibles: false,
            title: '添加客户等级',
            rules: {
                name: [
                    { required: true, message: '商城名称不能为空', trigger: 'blur' }
                ]
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            mode: 'add',
            form: {

            },
        }
    },
    created() {
        this.loadData();
        // this.getBrandList()
    },
    methods: {
        //获取表格列表
        // getBrandList() {
        //   request.get("/plug/invitation/list", {}).then((ret) => {
        //     if (ret.code == 200) {
        //       this.brandList = ret.data;
        //     } else {
        //       this.$message.error(ret.msg);
        //     }
        //   })
        // },
        loadData() {
            this.loading = true;
            //等级订单列表
            request.get('/account/grade/order/list', this.queryParams).then(ret => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.pageInfo = ret.data;
                    this.pageInfo.list = ret.data.list;
                    this.pageInfo.list.map(function (val) {
                        if (val.pay_time == 0) {
                            val.pay_time = ""
                        } else {
                            val.pay_time = deal.timestamp(val.pay_time, 'unix');
                        }

                    })
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        //分页
        changeQuery() {
            this.queryParams.page = 1
            this.loadData()
        },
        refreshPageSize(val) {
            this.queryParams.pagesize = val
            this.loadData()
        },
        refreshPageNum(val) {
            this.queryParams.page = val
            this.loadData()
        },
        //编辑
        edit(index, row) {
            this.mode = 'edit';
            this.title = '编辑';
            const item = this.pageInfo.list[index];
            let time = [item.stime, item.etime]
            //处理时间
            this.form = Object.assign({}, item);
            // console.log(4444,this.form)
            this.$set(this.form, 'time', time);
            console.log(1111111, this.form)
            this.addVisible = true;
        },
        //增加编辑
        saveData() {
            if (this.$refs.form) {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        //   this.form.num = this.form.countType == 1 ? 1 : this.form.num;
                        // this.form.brand_ids = this.form.brand_id;
                        var url = this.mode == 'add' ? '/account/grade/add' : '/account/grade/edit';
                        request.post(url, this.form).then(ret => {
                            if (ret.code == 1) {
                                this.addVisible = false;
                                this.addVisibles = false;
                                this.loadData();
                                this.$message.success((this.mode == 'add' ? '新增' : '编辑') +
                                    '成功');
                                this.$refs.form.clearValidate()
                            } else {
                                this.$message.error(ret.msg);
                            }
                        });
                    } else {
                        this.$message.error('请补全信息');
                        return false;
                    }
                });
            };
        },
        // 确定下线
        stateData() {
            request.post('/account/grade/edit', this.form).then(ret => {
                if (ret.code == 1) {
                    this.$message.success('操作成功');
                    this.loadData();
                    this.confirmVisible = false;
                } else {
                    this.$message.error(ret.msg);
                }
            });
        }
    }
}
</script>
<style scoped>
.red {
    color: #ff0000;
}

.green {
    color: green;
}
</style>